import { BLOCK_TYPES } from "../../common";
import { renderEditorCrossword } from "../Crossword";

const { COMPARE_ARRANGE_LIST_BLOCK } = BLOCK_TYPES;

const renderEditor = (props: any) =>
    renderEditorCrossword({
        ...props,
        blockType: COMPARE_ARRANGE_LIST_BLOCK,
        showFeedback: true,
    });

export default renderEditor;
